import { Typography } from "@mui/material";
import Loading from "./loading";

const LoadingPage = ({
  message = "Loading company information...",
}: {
  message?: string;
}) => {
  return (
    <>
      <Loading
        isLoading
        content={
          <Typography variant={"h6"} sx={{ pt: "20px" }}>
            {message}
          </Typography>
        }
      />
    </>
  );
};

export default LoadingPage;
